import { SegmentedControl } from "@joonapp/web-shared"
import { useEffect, useMemo } from "react"

import useClientTable from "./useClientTable"
import useAdminPageStore from "../hooks/useAdminpageStore"
import useClientTableFilterStore, {
  SelectedClientStatus,
} from "../hooks/useClientTableFilterStore"

const ClientStatusSegmentedControl = () => {
  const { selectedClientStatus, setSelectedClientStatus } =
    useClientTableFilterStore()
  const { selectedCoachProfileId } = useAdminPageStore()

  const { numActiveClients, numInactiveClients } = useClientTable()

  const options = useMemo(() => {
    return [
      {
        label: `Active (${numActiveClients})`,
        value: SelectedClientStatus.ACTIVE,
      },
      {
        label: `Inactive (${numInactiveClients})`,
        value: SelectedClientStatus.INACTIVE,
      },
    ]
  }, [numActiveClients, numInactiveClients])

  // When the coach profile is changed, set the selected client status to active
  useEffect(() => {
    setSelectedClientStatus(SelectedClientStatus.ACTIVE)
  }, [selectedCoachProfileId, setSelectedClientStatus])

  return (
    <SegmentedControl
      value={selectedClientStatus}
      options={options}
      setValue={(option) =>
        setSelectedClientStatus(option as SelectedClientStatus)
      }
    />
  )
}

export default ClientStatusSegmentedControl
